import { render, staticRenderFns } from "./cr-carrier-list.vue?vue&type=template&id=5008e859&scoped=true&"
import script from "./js/cr-carrier-list.js?vue&type=script&lang=js&"
export * from "./js/cr-carrier-list.js?vue&type=script&lang=js&"
import style0 from "./cr-carrier-list.vue?vue&type=style&index=0&id=5008e859&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008e859",
  null
  
)

export default component.exports